var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBannerChevron = function SvgBannerChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 7 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1C1C3A",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m1 1 4 4-4 4"
  })));
};
export default SvgBannerChevron;